module.exports = __webpack_public_path__ + "img/6D3B1C_895638_502A0D_844C31-256px.cacbf6b0.png";